import React from 'react';
import PropTypes from 'prop-types';
import { InfoCircleOutlined } from '@ant-design/icons';
import './index.less';

const prefixCls = 'eh-section-tips';

// 提示文本
const tipText = {
	shop: {
		bill: '对账单统计日期以账单明细中入账时间为准，如需下单时间维度的汇总，可在账单明细下载相应报表进行汇总。月汇总账单在次月首日6时生成。如遇特殊情况，则可能产生延迟生成情况，请谅解。',
		settlement:
			'结算单是用于和平台或企业结算储值卡消费、定额卡消费等费用。按每月1号出结算单，分别跟平台和各企业结算相应费用。商家确认结算单无误后，平台再基于结算单转账汇款给商家，最后变更结算 状态为已结算。如果对结算明细或结算流程有疑问，请咨询平台客服。',
	},
	mall: {
		bill: '商城作为结算主体与入驻商城的商家结算收入分成。按每月1号出结算单，分别跟各个企业结算相应费用。商家确认结算单无误后，商城再基于结算单转账汇款给商家，最后变更结算状态为已结算。如果对结算明细或结算流程有疑问，请咨询平台客服。',
		settlement:
			'商城作为结算对象和平台或企业结算储值卡消费、定额卡消费费用。按每月1号出结算单，分别跟平台和各企业结算相应费用。商城确认结算单无误后，平台再基于结算单转账汇款给商城，最后变更结算状态为已结算。如果对结算明细或结算流程有疑问，请咨询平台客服。',
	},
};

function SectionTips (props) {
	const { type, title, Icon, theme } = props;
	return (
		<div className={prefixCls}>
			{Icon || <InfoCircleOutlined className={`${prefixCls}-icon`} />}
			<h3 className={`${prefixCls}-icon_desc`}>{title}</h3>
			<p className={`${prefixCls}-desc`}>{tipText[theme][type]}</p>
		</div>
	);
}

SectionTips.defaultProps = {
	title: '帮助信息',
	type: 'bill',
	theme: 'shop',
	Icon: '',
};

SectionTips.propTypes = {
	title: PropTypes.string,
	type: PropTypes.string,
	Icon: PropTypes.element,
	theme: PropTypes.string,
};

export default SectionTips;
